import React, { createContext } from "react";
import QueryNavigatorItem2 from "noood/net/QueryNavigatorItem2";
import { ArrayUtil } from "noood/util/array/ArrayUtil";
import QueryNavigator2 from "noood/net/QueryNavigator2";
import PageNotFound from "noood/comp/no-records/PageNotFound";
import * as stylex from "@stylexjs/stylex";
import Spacer from "noood/comp/ui/spacer/Spacer";
import { useLocation } from "react-router";
import ErrorBoundary from "noood/comp/ErrorBoundary";
export var DomainSubNavigator2Context = /*#__PURE__*/createContext();
export default function DomainSubNavigator2(props) {
  var _URLSearchParams$get, _props$menuItems, _ArrayUtil$id_is$cont, _ArrayUtil$id_is;
  var loc = useLocation();
  var filterValue = (_URLSearchParams$get = new URLSearchParams(loc.search).get(props.queryFilter)) !== null && _URLSearchParams$get !== void 0 ? _URLSearchParams$get : props.defaultHighlight;
  var contextObj = {
    parentPath: props.parentPath
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DomainSubNavigator2Context.Provider, {
    value: contextObj
  }, /*#__PURE__*/React.createElement(QueryNavigator2, {
    highlight_prop: props.queryFilter,
    default_highlight: props.defaultHighlight
  }, (_props$menuItems = props.menuItems) === null || _props$menuItems === void 0 ? void 0 : _props$menuItems.map(function (item, idx) {
    return item.show || item.show === void 0 ? /*#__PURE__*/React.createElement(QueryNavigatorItem2, {
      queryString: item.queryString,
      queryFilter: props.queryFilter,
      item: item,
      parentPath: props.parentPath,
      defaultMenu: props.defaultHighlight,
      key: idx
    }) : /*#__PURE__*/React.createElement(React.Fragment, null);
  })), /*#__PURE__*/React.createElement(ErrorBoundary, {
    key: "".concat(window.location.pathname, "?").concat(window.location.search)
  }, (_ArrayUtil$id_is$cont = (_ArrayUtil$id_is = ArrayUtil.id_is(props.menuItems, 'id', filterValue)) === null || _ArrayUtil$id_is === void 0 ? void 0 : _ArrayUtil$id_is.content) !== null && _ArrayUtil$id_is$cont !== void 0 ? _ArrayUtil$id_is$cont : /*#__PURE__*/React.createElement(PageNotFound, null)), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 100
  })));
}

// @ts-ignore